export const DELIVERY_MINIMUM_MS = 24 * 60 * 60 * 1000;

function localDateValue(date: Date): string {
  const year = String(date.getFullYear()).padStart(4, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function minimumDeliveryDateValue(now = new Date()): string {
  if (!Number.isFinite(now.getTime())) return '';
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  return localDateValue(tomorrow);
}

export function resolveDeliveryDeadlineFromDate(value: string, now = new Date()): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !Number.isFinite(now.getTime())) return null;
  const [year, month, day] = value.split('-').map(Number);
  const deadline = new Date(year, month - 1, day, 23, 59, 59, 999);
  if (
    deadline.getFullYear() !== year ||
    deadline.getMonth() !== month - 1 ||
    deadline.getDate() !== day ||
    deadline.getTime() - now.getTime() < DELIVERY_MINIMUM_MS
  ) {
    return null;
  }
  return deadline;
}
